module.exports = __webpack_public_path__ + "img/06.8a54d10.png";